module.exports = __webpack_public_path__ + "img/logo_.da209072.png";